import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index/Index'
import Quiz from '@/components/quiz/Index'
import Gdpr from '@/components/Gdpr'
import InArray from '@/components/helpers/inArray'
import MainPages from './mainPages'
import VueScrollTo from 'vue-scrollto'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {gtm: 'index'}
    },
    {
      path: '/quiz',
      name: 'Quiz',
      component: Quiz,
      meta: {gtm: 'quiz'}
    },
    {
      path: '/pasty',
      name: 'PasteList',
      component: Index,
      meta: {gtm: 'index'}
    },
    {
      path: '/gdpr',
      name: 'Gdpr',
      component: Gdpr,
      meta: {gtm: 'gdpr'}
    },
    {
      path: '/:paste',
      name: 'Paste',
      component: Index,
      meta: {gtm: 'pasta'}
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (InArray(to.name, MainPages)) {
      // timeout to make transition have effect
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 })
        }, 100)
        if (to.name === 'PasteList') {
          setTimeout(() => {
            VueScrollTo.scrollTo('.toothbrushes')
          }, 150)
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js